import type { InjectedParameters } from "@wagmi/core";
import { injected } from "wagmi";
export function okxConnector(parameters?: InjectedParameters) {
	return injected({ target: "okxWallet", ...parameters, shimDisconnect: true });
}
